<template>
	<div>
		<transition name="fade">
			<fixed-header :threshold="150">
				<nav class="navbar navbar-toggleable navbar-expand-lg navbar-dark">
					<div class="container position-relative ">
						<router-link to="/" class="navbar-brand ">
							<img
								class="navbar-brand__regular img-fluid d-lg-inline-block d-none"
								src="/assets/logo.png"
								alt="brand-logo"
								height="75px"
								width="75px"
							/>
							<img
								class="navbar-brand__sticky img-fluid  d-inline-block d-lg-none"
								src="/assets/logo.png"
								alt="sticky brand-logo"
								height="63px"
								width="63px"
							/>
						</router-link>

						<!--  End of brand logo -->
						<button
							class="navbar-toggler mr-0 "
							type="button"
							data-toggle="collapse"
							data-target="#navbar1"
						>
							<span class="navbar-toggler-icon"></span>
						</button>
						<!-- end of Nav toggler -->

						<!-- <nav> -->
						<div
							class="collapse navbar-collapse navbar-dark pr-0 pl-0 pl-lg-8  mr-0 ml-2 pl-sm-3 "
							id="navbar1"
						>
							<ul class="navbar-nav" id="navbar-nav">
								<li class="nav-item dropdown">
									<router-link to="/" class="nav-link">{{
										$t("header.home")
									}}</router-link>
								</li>
								<!-- <li class="nav-item dropdown">
									<router-link to="/#suppliers" class="nav-link "
										>{{ $t("header.shops") }}
									</router-link>
								</li> -->
								<!-- <li class="nav-item dropdown">
									<router-link to="/blog" class="nav-link"
										>{{ $t("header.blog") }}
									</router-link>
								</li> -->
								<li class="nav-item dropdown">
									<router-link to="/#features" class="nav-link"
										>{{ $t("header.aboutUs") }}
									</router-link>
								</li>
								<li class="nav-item dropdown">
									<router-link to="/contact-us" class="nav-link"
										>{{ $t("header.contactUs") }}
									</router-link>
								</li>
							</ul>
							<!-- end of nav menu items -->
						</div>

						<div class="pr-4 pl-0 pr-lg-0 pl-lg-0">
							<!-- LOGIN -->
							<router-link
								v-if="!isLoggedIn && !isSupplierLoggedIn"
								to="/newlogin"
								class="btn btn-size--md btn-hover--3d btn-bg--primary"
								><span class="btn__text">{{
									$t("header.login")
								}}</span></router-link
							>
							<!-- COSTUMER NAME -->
							<span v-if="isLoggedIn" class=" nav-item text-white"
								><router-link
									to="/customer"
									class="users_name font-size--13   font-w--400"
								>
									{{ getUsersFirstName + " " + getUsersLastName }}</router-link
								>
								|
								<button
									class="font-size--14   font-w--500 users_name"
									@click.prevent="logout"
								>
									خروج
								</button></span
							>

							<!-- SUPLLIER NAME -->
							<span v-else-if="isSupplierLoggedIn" class=" nav-item text-white"
								><router-link
									to="/supplier"
									class="users_name font-size--13   font-w--400"
								>
									{{ getSupplierName }}</router-link
								>
								|
								<button
									class="font-size--14   font-w--500 users_name"
									@click.prevent="supplierLogOut"
								>
									خروج
								</button></span
							>
						</div>
						<!-- end of nav CTA button -->
					</div>
					<!-- end of container -->
				</nav>
			</fixed-header>
		</transition>
	</div>
</template>

<script>
	import FixedHeader from "vue-fixed-header";

	export default {
		data() {
			return {
				isFixed: false,
				lastScrollTop: 0
			};
		},
		computed: {
			isLoggedIn() {
				return this.$store.getters.isLoggedIn;
			},
			getUsersFirstName() {
				return this.$store.getters.getFirstName;
			},
			getUsersLastName() {
				return this.$store.getters.getLastName;
			}
		},
		methods: {
			logout: function() {
				this.$store.dispatch("logOut").then(() => {
					this.$router.push("/");
				});
			}
		},
		components: {
			FixedHeader
		}
	};
</script>



<style scoped>
	.vue-fixed-header {
		/* height: 81px; */
		padding: 0 0 0 0;
	}
	.navbar.vue-fixed-header--isFixed {
		position: fixed;
		/* height: 81px; */
		padding: 0 0 0 0;
		background: #272a33;
	}
	.navbar-dark {
		background: #272a33;
	}
</style>


